import React from 'react'
import { Modal, Box, Typography, IconButton } from '@mui/material'
import styles from './ViewTimeOffModal.module.scss'

const ViewTimeOffModal = ({ open, onClose, requestData }) => {
	if (!requestData) return null

	const getStatusColor = (status) => {
		const statusLower = status.toLowerCase()
		switch (statusLower) {
			case 'approved':
				return '#10B981'
			case 'rejected':
				return '#EF4444'
			case 'pending':
				return '#F59E0B'
			default:
				return '#6B7280'
		}
	}

	const getStatusIcon = (status) => {
		const statusLower = status.toLowerCase()
		switch (statusLower) {
			case 'approved':
				return '✓'
			case 'rejected':
				return '✗'
			case 'pending':
				return '⏳'
			default:
				return '•'
		}
	}

	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="view-modal-title"
			aria-describedby="view-modal-desc"
			className={styles.backdrop}
		>
			<Box className={styles.modal} role="dialog" aria-modal="true">
				<IconButton
					aria-label="close"
					className={styles.closeBtn}
					onClick={onClose}
					size="large"
				>
					<img src="/images/modal-close-icon.svg" alt="close" />
				</IconButton>

				<h3 id="view-modal-title" className={styles.title}>
					Time Off Request Details
				</h3>

				<div className={styles.detailsContainer}>
					<div className={styles.detailRow}>
						<span className={styles.label}>Date:</span>
						<span className={styles.value}>{requestData.date}</span>
					</div>

					<div className={styles.detailRow}>
						<span className={styles.label}>Time Off Type:</span>
						<span className={styles.value}>{requestData.TimeOffType}</span>
					</div>

					<div className={styles.detailRow}>
						<span className={styles.label}>Leave Duration:</span>
						<span className={styles.value}>{requestData.leaveDuration || '-'}</span>	
					</div>
					
					<div className={styles.detailRow}>
						<span className={styles.label}>Reason:</span>
						<span className={styles.value}>{requestData.ReasonForTimeOff}</span>
					</div>

					<div className={styles.detailRow}>
						<span className={styles.label}>Status:</span>
						<span 
							className={styles.statusBadge}
							style={{ 
								backgroundColor: getStatusColor(requestData.status),
								color: '#ffffff'
							}}
						>
							{getStatusIcon(requestData.status)} {requestData.status}
						</span>
					</div>
				</div>
			</Box>
		</Modal>
	)
}

export default ViewTimeOffModal
